<template>
  <div class="file-download-page">
    <div class="download-panel">
      <!-- 标题 -->
      <div class="panel-title">
        <!-- <img 
          class="logo-icon" 
          src="https://cdn01.xiaogj.com/uploads/fe/xzt-new/sm-xzt/pc/0004.png" 
          alt="logo"
        /> -->
        <span>文件下载</span>
      </div>

      <!-- 加载状态 -->
      <div v-if="!loaded" class="loading-box">
        <div class="spinner"></div>
        <p>加载中...</p>
      </div>

      <!-- 加载完成后显示内容 -->
      <template v-else>
        <!-- 有效期提示 -->
        <div v-if="downloadItem && downloadItem.expireTime" class="desc-text">
          已生成临时下载文件，有效期24小时（<span class="expire-time">{{ formatExpireTime(downloadItem.expireTime) }}</span> 失效），请及时下载
        </div>
        
        <!-- 下载内容区 -->
        <div class="content-box">
          <!-- 错误提示 -->
          <div v-if="errorMessage" class="error-box">
            <div class="error-icon">⚠️</div>
            <p>{{ errorMessage }}</p>
          </div>

          <!-- 下载项 -->
          <div v-else-if="downloadItem && downloadItem.fileUrl" class="download-item">
            <div class="file-info">
              <!-- <div class="file-icon">📄</div> -->
              <div class="file-name">{{ downloadItem.fileName }}</div>
            </div>
            <button class="download-btn" @click="handleDownload(downloadItem)">
              下载
            </button>
          </div>

          <!-- 无文件 -->
          <div v-else class="empty-box">
            <!-- <div class="empty-icon"></div> -->
            <p>暂无可下载文件</p>
          </div>
        </div>
      </template>
    </div>

    <!-- Toast 提示 -->
    <div v-if="toast.show" class="toast-mask">
      <div class="toast-box">
        <div v-if="toast.type === 'loading'" class="toast-spinner"></div>
        <div v-else-if="toast.type === 'success'" class="toast-icon">✓</div>
        <div v-else-if="toast.type === 'error'" class="toast-icon">✕</div>
        <p>{{ toast.message }}</p>
      </div>
    </div>

    <!-- Dialog 弹窗 -->
    <div v-if="dialog.show" class="dialog-mask" @click="closeDialog">
      <div class="dialog-box" @click.stop>
        <div class="dialog-title">{{ dialog.title }}</div>
        <div class="dialog-content">{{ dialog.message }}</div>
        <div class="dialog-footer">
          <button class="dialog-btn" @click="closeDialog">{{ dialog.confirmText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/index'

export default {
  name: 'FileDownload',
  
  data() {
    return {
      queryToken: '',
      downloadItem: null,
      loaded: false,
      errorMessage: '',
      toast: {
        show: false,
        type: 'loading', // loading, success, error
        message: ''
      },
      dialog: {
        show: false,
        title: '提示',
        message: '',
        confirmText: '我知道了'
      }
    }
  },

  mounted() {
    app.tool.setDocTitle('下载文件');
    const token = this.$route.query.token
    
    if (token) {
      this.queryToken = token
      this.fetchDownloadInfo(token)
    } else {
      this.showDialog('提示', 'Token参数不能为空')
      this.loaded = true
    }
  },

  methods: {
    // 显示Toast
    showToast(message, type = 'loading', duration = 2000) {
      this.toast = { show: true, message, type }
      if (type !== 'loading' && duration > 0) {
        setTimeout(() => {
          this.toast.show = false
        }, duration)
      }
    },

    // 隐藏Toast
    hideToast() {
      this.toast.show = false
    },

    // 显示Dialog
    showDialog(title, message, confirmText = '我知道了') {
      this.dialog = { show: true, title, message, confirmText }
    },

    // 关闭Dialog
    closeDialog() {
      this.dialog.show = false
    },

    // 获取下载信息
    async fetchDownloadInfo(token) {
      this.showToast('加载中...', 'loading', 0)

      try {
        const res = await this.$api.fileDownloadInfo({ token })
        
        if ((res.code === 200) && res.data) {
          this.downloadItem = {
            fileName: res.data.fileName,
            fileUrl: res.data.fileUrl,
            expireTime: res.data.expireTime
          }
          this.errorMessage = ''
        } else {
          this.errorMessage = res.msg || '获取下载信息失败'
        }
      } catch (error) {
        console.error('获取下载信息失败:', error)
        this.errorMessage = error.message || '获取下载信息失败，请稍后重试'
      } finally {
        this.loaded = true
        this.hideToast()
      }
    },

    // 格式化过期时间
    formatExpireTime(timestamp) {
      if (!timestamp) return ''
      
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },

    // 检查是否过期
    checkExpired(expireTime) {
      if (!expireTime) return false
      
      const now = new Date().getTime()
      
      return now > expireTime
    },

    // 下载文件
    async handleDownload(item) {
      if (!item.fileUrl) {
        this.showToast('下载链接不存在', 'error')
        return
      }

      // 检查是否过期
      if (this.checkExpired(item.expireTime)) {
        this.showDialog('提示', '文件已过期', '确定')
        setTimeout(() => {
          window.location.reload()
        }, 1500)
        return
      }
      
      // 检测是否在微信环境中
      const isWeixinBrowser = /micromessenger/i.test(navigator.userAgent)
      if (isWeixinBrowser) {
        this.showDialog('下载提示', '请点击右上角"..."，选择在浏览器中打开后进行下载', '我知道了')
        return
      }

      this.showToast('正在下载...', 'loading', 0)

      try {

        // 检测是否为苹果设备
        const isAppleDevice = /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)
        let response={};
        if (!isAppleDevice) {
          response = await fetch(item.fileUrl, {
            headers: {
              Referer:`${window.location.origin}/`
            }
          })
        }else{
          response = await fetch(item.fileUrl)
        }

        if (!response.ok) {
          throw new Error(`下载失败: ${response.statusText}`)
        }

        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = item.fileName || 'download'
        document.body.appendChild(a)
        a.click()
        
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
        
        this.hideToast()
        this.showToast('下载成功', 'success')
      } catch (error) {
        console.error('下载失败:', error)
        this.hideToast()
        this.showToast(error.message || '下载失败，请重试', 'error')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.file-download-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: #f5f7fa;

  .download-panel {
    width: 100%;
    max-width: 500px;
    min-height: 280px;
    background: #ffffff;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    padding: 30px 20px;

    .panel-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin-bottom: 20px;

      .logo-icon {
        width: 60px;
        height: 22px;
        margin-right: 12px;
      }
    }

    .loading-box {
      text-align: center;
      padding: 40px 0;

      .spinner {
        width: 40px;
        height: 40px;
        margin: 0 auto 16px;
        border: 3px solid #f3f3f3;
        border-top: 3px solid #667eea;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      p {
        color: #999;
        font-size: 14px;
      }
    }

    .desc-text {
      text-align: center;
      color: #666;
      font-size: 13px;
      line-height: 1.6;
      margin-bottom: 24px;
      padding: 0 10px;
      
      .expire-time {
        color: #ff6b6b;
        font-weight: 600;
      }
    }

    .content-box {
      .error-box,
      .empty-box {
        text-align: center;
        padding: 30px 20px;

        .error-icon,
        .empty-icon {
          font-size: 48px;
          margin-bottom: 12px;
        }

        p {
          color: #999;
          font-size: 14px;
        }
      }

      .download-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        background: #f8f9fa;
        border-radius: 12px;
        transition: all 0.3s;

        &:active {
          transform: scale(0.98);
          background: #e9ecef;
        }

        .file-info {
          flex: 1;
          display: flex;
          align-items: center;
          margin-right: 12px;
          min-width: 0;

          .file-icon {
            font-size: 32px;
            margin-right: 12px;
            flex-shrink: 0;
          }

          .file-name {
            font-size: 15px;
            font-weight: 500;
            color: #333;
            word-break: break-all;
            line-height: 1.4;
          }
        }

        .download-btn {
          flex-shrink: 0;
          padding: 10px 20px;
          background: rgb(34, 132, 254);
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;

          &:active {
            transform: translateY(1px);
          }
        }
      }
    }
  }

  // Toast样式
  .toast-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    pointer-events: none;

    .toast-box {
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 16px 20px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 120px;
      pointer-events: auto;

      .toast-spinner {
        width: 32px;
        height: 32px;
        border: 3px solid rgba(255, 255, 255, 0.3);
        border-top: 3px solid white;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 8px;
      }

      .toast-icon {
        width: 32px;
        height: 32px;
        line-height: 32px;
        font-size: 24px;
        margin-bottom: 8px;
      }

      p {
        font-size: 14px;
        margin: 0;
        text-align: center;
      }
    }
  }

  // Dialog样式
  .dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;

    .dialog-box {
      background: white;
      border-radius: 12px;
      width: 80%;
      max-width: 320px;
      overflow: hidden;

      .dialog-title {
        padding: 20px 20px 10px;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        text-align: center;
      }

      .dialog-content {
        padding: 10px 20px 20px;
        font-size: 14px;
        color: #666;
        text-align: center;
        line-height: 1.6;
      }

      .dialog-footer {
        border-top: 1px solid #eee;
        
        .dialog-btn {
          width: 100%;
          padding: 14px;
          background: none;
          border: none;
          color: #667eea;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;

          &:active {
            background: #f5f5f5;
          }
        }
      }
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}
</style>
